import React from 'react';
const problems = [{
  title: 'Confiaste en "la química"',
  description: 'Pensaste que si se sentía bien, era real. La química es el camuflaje perfecto para la inconsistencia.'
}, {
  title: 'Pediste consejos a ciegas',
  description: 'Consultaste con amigas que están tan confundidas como tú. La opinión no reemplaza a los datos.'
}, {
  title: 'Esperaste a que "él cambiara"',
  description: 'El tiempo no cambia a los hombres, solo revela quiénes son. No esperes 6 meses para ver lo que puedes detectar hoy.'
}];
export function ProblemCards() {
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-239">
      <h2 className="text-[clamp(22px,6vw,32px)] font-extrabold leading-tight mb-6" data-id="element-240">
        ¿Cuántas veces has sentido que desperdiciaste meses con el hombre
        equivocado?
      </h2>

      {problems.map((problem, index) => <div key={index} className="bg-[var(--card)] rounded-xl p-5 mb-3.5 border-l-[3px] border-[var(--red)]" data-id="element-241">
          <div className="text-2xl text-[var(--accent)] font-black mb-2" data-id="element-242">✕</div>
          <h3 className="text-[17px] font-bold mb-1" data-id="element-243">{problem.title}</h3>
          <p className="text-[var(--muted)] text-sm leading-relaxed" data-id="element-244">
            {problem.description}
          </p>
        </div>)}

      <div className="mt-6 text-center" data-id="element-245">
        <p className="text-white text-[17px] leading-relaxed font-semibold" data-id="element-246">
          El problema no eres tú, es tu radar.
        </p>
        <p className="text-[var(--muted)] text-[15px] leading-relaxed mt-1" data-id="element-247">
          Estás usando emociones para medir comportamientos. Necesitas un
          sistema binario.
        </p>
      </div>
    </section>;
}